<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form
        :model="form.carParkingSpace"
        ref="formRef"
        :rules="formRules"
        label-suffix=":"
        label-width="105px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <span>车位信息</span>
            <el-divider></el-divider>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属车场">
              <el-select
                v-model="form.carParkingSpace.spaceId"
                disabled
                style="width:100%"
                placeholder="请选择所属车场"
                @change="spaceIdChange"
              >
                <el-option
                  v-for="item in spaceIdList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="所属区域">
              <el-select
                disabled
                v-model="form.carParkingSpace.regionId"
                style="width:100%"
                placeholder="请选择所属区域"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.spaceName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车位编号">
              <el-input
                clearable
                disabled
                v-model="form.carParkingSpace.name"
                placeholder="车位编号"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="子母车位">
              <el-select
                disabled
                v-model="form.carParkingSpace.isDouble"
                style="width:100%"
                placeholder="车位状态"
                clearable
              >
                <el-option
                  v-for="item in isDoubleData"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车位性质">
              <el-select disabled v-model="form.carParkingSpace.parkingSpaceNature" style="width:100%" placeholder="车位性质" clearable>
                <el-option
                  v-for="item in parkingSpaceNatureDict"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="业主姓名">
              <el-input
                clearable
                disabled
                v-model="form.carParkingSpace.personName"
                placeholder="请输入业主姓名"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="业主电话">
              <el-input
                clearable
                disabled
                v-model="form.carParkingSpace.personPhone"
                placeholder="请输入业主电话"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="房间号">
              <el-input
                clearable
                disabled
                v-model="form.carParkingSpace.roomName"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>


        </el-row>
      </el-form>
      <el-form
        :model="form.arrearsInfo"
        ref="formRef"
        :rules="formRules"
        label-suffix=":"
        label-width="105px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <span>欠费信息</span>
            <el-divider></el-divider>
          </el-col>
          <el-col :span="16">
            <el-form-item label="欠费周期" style="">
              <el-input
                clearable
                disabled
                v-model="form.arrearsInfo.arrearsCycle"
                style="width: 30%;height: 32px;"
                maxlength="20"
              ></el-input>
              <el-date-picker
                v-model="form.arrearsInfo.cycleList"
                type="daterange"
                readonly
                style="width: 60%;margin-left: 10px;transform: translateY(3px);"
                range-separator="~"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="当前欠费" prop="arrearsAmount">
              <money-input
                disabled
                v-model="form.arrearsInfo.arrearsAmount"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form
        :model="form.carParkingSpaceFeeInfo"
        ref="formRef"
        :rules="formRules"
        label-suffix=":"
        label-width="105px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <span>费用预收</span>
            <el-divider></el-divider>
          </el-col>
          <el-col :span="16">
            <el-form-item label="缴费时长" prop="cycleNum">
              <el-select
                v-model="form.carParkingSpaceFeeInfo.cycleNum"
                style="width: 30%;height: 32px;"
                placeholder="请选择缴费时长"
                @change="cycleNumChange"

              >
                <el-option
                  v-for="item in feeCyclelList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
              <el-date-picker  readonly v-model="form.carParkingSpaceFeeInfo.cycleList" type="daterange" range-separator="~"   style="width: 60%;height: 32px;margin-left: 10px;transform: translateY(3px);">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收费标准" prop="feeRuleId">
              <el-select disabled v-model="form.carParkingSpaceFeeInfo.feeRuleId" style="width:100%">
                <el-option
                  v-for="item in carRuleList"
                  :key="item.id"
                  :label="item.setmealName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 优惠规则 -->
          <el-col :span="8" v-if="bestCarRuleDiscountList.length>0">
            <el-form-item label="优惠规则" >
              <el-select clearable  v-model="form.carParkingSpaceFeeInfo.feeRuleDiscountId" style="width:100%" @change="feeRuleDiscountChange">
                <el-option
                  v-for="item in bestCarRuleDiscountList"
                  :key="item.id"
                  :label="item.discountName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 优惠金额 -->
          <el-col :span="8" v-if="bestCarRuleDiscountList.length>0">
            <el-form-item label="优惠金额" prop="discountAmount">
              <money-input
                disabled
                v-model="form.carParkingSpaceFeeInfo.discountAmount"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <!-- 应收金额 -->
          <el-col :span="8">
            <el-form-item label="应收金额" prop="shouldAmount">
              <money-input
                disabled
                v-model="form.carParkingSpaceFeeInfo.shouldAmount"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="实收金额" prop="payAmount">
              <money-input
                disabled
                v-model="form.carParkingSpaceFeeInfo.payAmount"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款方式" prop="payType">
              <el-select v-model="form.carParkingSpaceFeeInfo.payType" @change="payTypeChange">
                <el-option
                  v-for="item in payTypeList"
                  :key="item"
                  :value="item.dictKey"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.carParkingSpaceFeeInfo.payType==2||form.carParkingSpaceFeeInfo.payType==3">
            <el-form-item label="收款类型" prop="payScene" >
              <el-select v-model="form.carParkingSpaceFeeInfo.payScene">
                <el-option
                  v-for="item in paySceneList"
                  :key="item"
                  :value="item.dictKey"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.carParkingSpaceFeeInfo.payScene==6">
            <el-form-item label="收款码" prop="authCode">
              <el-input type="password" clearable v-model="form.carParkingSpaceFeeInfo.authCode" maxlength="20" @change="authCodeChange" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="description">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入备注"
                v-model="form.carParkingSpaceFeeInfo.description"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="    text-align: right;">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        保存
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
        取消
      </el-button>
    </div>
    <el-dialog
      title=" 收款码"
      :visible.sync="payInfo2.showQrCode"
      :close-on-click-modal="false"
      width="30%"
      top="16vh"
      append-to-body
      :show-close="false"
      @close="closeQrCode"
    >
      <div style="text-align: center; color: red; font-size: 2rem; padding: 1rem 0">
        {{ payInfo2.tradeStatus === 2 ? '付款成功' : '付款中' }}
      </div>
      <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
        扫码支付后请勿手动关闭弹窗
      </div>
      <div style="text-align: center">
        <div id="qrcodeCar" ref="qrcode" style="display: inline-block"></div>
        <div>倒计时：{{ payInfo2.countdown }}</div>
      </div>
    </el-dialog>

  </div>

</template>
<script>
import QRCode from 'qrcodejs2';
import { getDictionary } from '@/api/common.js';
import { getPayTypeListforSpaceId, getPaySceneList } from '@/api/chargev2/charge-pay';
import {
  spaceFeeInfo,
  getParkList,
  getRegionList,
  getCarRuleList,
  getBuildingList,
  getRoomList,
  spaceSave,
  spaceCalculateFee,
  spacePay,
  spacePayQuery,
  bestCarRuleDiscountList
} from './index.js';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    spaceId: {},
    model: {},
  },
  data() {
    return {
      loading:false,
      showQrCode:false,
      payTypeList: [],
      paySceneList: [],
      spaceStatusData: [
        {
          dictKey: '1',
          dictValue: '空闲',
        },
        {
          dictKey: '2',
          dictValue: '已出售',
        },
      ],
      isDoubleData: [
        {
          dictKey: 0,
          dictValue: '否',
        },
        {
          dictKey: 1,
          dictValue: '是',
        },
      ],
      parkingSpaceNatureDict:[
        {
          dictKey: 1,
          dictValue:'车位',
        },
        {
          dictKey: 2,
          dictValue:'车库',
        },
      ],
      regionList: [],

      form: {
        arrearsInfo: {},
        carParkingSpace: {},
        carParkingSpaceFeeInfo: {},
      },

      formRules: {
        spaceId: [{ required: true, message: '所属车场不能为空', trigger: 'blur' }],
        regionId: [{ required: true, message: '所属区域不能为空', trigger: 'change' }],
        name: [{ required: true, message: '车位编号不能为空', trigger: 'change' }],
        spaceStatus: [{ required: true, message: '车位状态不能为空', trigger: 'blur' }],
        isDouble: [{ required: true, message: '子母车位不能为空', trigger: 'change' }],
        personName: [{ required: true, message: '业主姓名不能为空', trigger: 'change' }],
        personPhone: [{ required: true, message: '业主电话不能为空', trigger: 'change' }],
        roomId: [{ required: true, message: '房间名称不能为空', trigger: 'change' }],
        buildingId: [{ required: true, message: '楼栋/单元不能为空', trigger: 'change' }],
        feeRuleId: [{ required: true, message: '收费套餐不能为空', trigger: 'change' }],
        payType: [{ required: true, message: '收款方式不能为空', trigger: 'change' }],
        payScene:[{ required: true, message: '收款类型不能为空', trigger: 'change' }],
        cycleNum:[{ required: true, message: '缴费时长不能为空', trigger: 'change' }],
      },
      tableHeight: '',
      spaceIdList: [],
      carRuleList: [],
      buildingList: [],
      roomList: [],
      feeCyclelList: [],
      payInfo2: {
        showQrCode: false,
        tradeStatus: '',
        countdown: '',
      },
      payInfo:{},
      bestCarRuleDiscountList:[],
      authCodeInfo:{
        payStatus:0,
        timer:null
      }
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    authCodeInput(){
      console.log("input")
    },
    feeRuleDiscountChange(val){
      console.log(val)
      this.form.carParkingSpaceFeeInfo.cycleList=[]
      this.form.carParkingSpaceFeeInfo.shouldAmount =''
        this.form.carParkingSpaceFeeInfo.payAmount =''
      spaceCalculateFee({
        feeRuleId:this.form.carParkingSpaceFeeInfo.feeRuleId,
        feeStartTime:this.form.carParkingSpaceFeeInfo.feeStartTime,
        cycleNum:this.form.carParkingSpaceFeeInfo.cycleNum,
        feeRuleDiscountId:val,
        area:this.form.carParkingSpace.area,
      }).then(res=>{
        this.form.carParkingSpaceFeeInfo.cycleList=[this.form.carParkingSpaceFeeInfo.feeStartTime,res.data.feeEndTime]
        this.form.carParkingSpaceFeeInfo.feeEndTime=res.data.feeEndTime
        this.form.carParkingSpaceFeeInfo.shouldAmount =res.data.shouldAmount
        this.form.carParkingSpaceFeeInfo.payAmount =res.data.payAmount
        this.form.carParkingSpaceFeeInfo.discountAmount =res.data.discountAmount
      })
    },
    closeQrCode() {
      setTimeout(() => {
        this.$refs.qrcode.innerHTML = '';
      }, 300);
      clearInterval(this.payInfo2.timer);
    },





   async cycleNumChange(){
      this.form.carParkingSpaceFeeInfo.cycleList=[]
      this.form.carParkingSpaceFeeInfo.shouldAmount =''
        this.form.carParkingSpaceFeeInfo.payAmount =''
    await  bestCarRuleDiscountList({
        spaceId:this.row.spaceId,
        carFeeRuleId:this.form.carParkingSpaceFeeInfo.feeRuleId,
        payPeriods:this.form.carParkingSpaceFeeInfo.cycleNum,
        area:this.form.carParkingSpace.area,
      }).then(res=>{
        this.bestCarRuleDiscountList = res.data
        if(res.data.length>0){
          //默认第一个优惠规则
          this.$set(this.form.carParkingSpaceFeeInfo,'feeRuleDiscountId',res.data[0].id)
        }
      })
      spaceCalculateFee({
        feeRuleId:this.form.carParkingSpaceFeeInfo.feeRuleId,
        feeStartTime:this.form.carParkingSpaceFeeInfo.feeStartTime,
        cycleNum:this.form.carParkingSpaceFeeInfo.cycleNum,
        feeRuleDiscountId:this.form.carParkingSpaceFeeInfo.feeRuleDiscountId,
        area:this.form.carParkingSpace.area,
      }).then(res=>{
        this.form.carParkingSpaceFeeInfo.cycleList=[this.form.carParkingSpaceFeeInfo.feeStartTime,res.data.feeEndTime]
        this.form.carParkingSpaceFeeInfo.feeEndTime=res.data.feeEndTime
        this.form.carParkingSpaceFeeInfo.shouldAmount =res.data.shouldAmount
        this.form.carParkingSpaceFeeInfo.payAmount =res.data.payAmount
        this.form.carParkingSpaceFeeInfo.discountAmount =res.data.discountAmount
      })
    },
    payTypeChange(val) {
      this.paySceneList=[]
      this.form.carParkingSpaceFeeInfo.payScene =''
      this.getPaySceneList(val)
    },
    initData() {
      console.log(this.row);
      getDictionary('park_fee_cycle').then((res) => {
        this.feeCyclelList = res.data;
      });
      getParkList().then((res) => {
        this.spaceIdList = res.data;
      });
      spaceFeeInfo({ id: this.row.id }).then((res) => {
        this.form = res.data;
       this. form.carParkingSpaceFeeInfo.cycleNum+=''
        this.form.arrearsInfo.cycleList=[this.form.arrearsInfo.startTime,this.form.arrearsInfo.endTime]
        this.form.carParkingSpaceFeeInfo.cycleList=[this.form.carParkingSpaceFeeInfo.feeStartTime,this.form.carParkingSpaceFeeInfo.feeEndTime]
        this.getpayTypeList(this.form.carParkingSpace.spaceId)
        getRegionList({
          spaceId: this.form.carParkingSpace.spaceId,
        }).then((res) => {
          this.regionList = res.data;
        });
        this.getCarRuleList(this.form.carParkingSpace.spaceId);
      });

    },
    getPaySceneList(val) {
      getPaySceneList({ payType: val }).then((res) => {
        this.paySceneList = res.data;
      });
    },
    getpayTypeList(val) {
      getPayTypeListforSpaceId({ spaceId: val }).then((res) => {
        this.payTypeList = res.data;
      });
    },

    getCarRuleList(spaceId) {
      getCarRuleList({ spaceId: spaceId, packageType: 2 }).then((res) => {
        this.carRuleList = res.data;
      });
    },
    getBuildingList(spaceId) {
      getBuildingList({ spaceId: spaceId }).then((res) => {
        this.buildingList = res.data;
      });
    },
    getRoomList(buildingId) {
      getRoomList({ buildingId: buildingId }).then((res) => {
        this.roomList = res.data;
      });
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          if(this.form.carParkingSpaceFeeInfo.payScene==5){
            this.qrCodePay()
          }else if(this.form.carParkingSpaceFeeInfo.payScene==6){
            //扫描付款码收款
            this.devicePay()
          }
          else{
            spacePay(this.form).then(res=>{
              this.$message.success("操作成功");
              this.$emit('success');
            })
          }
        } else {
        }
      });
    },
    devicePay() {
      spacePay(this.form,{ showLoading: { text: '正在获取信息' } }).then(({data})=>{
       this.payInfo2.showQrCode= true
          this.payInfo.orderNo = data.orderNo;

              this.payInfo2.countdown = 120;
          this.payInfo2.timer = setInterval(() => {
            if (this.payInfo2.countdown === 0) {
              clearInterval(this.payInfo2.timer);
              this.payInfo2.showQrCode = false;
              this.$message.info('倒计时结束，弹窗关闭');
              this.$emit('success');
              // this.$confirm('收费失败，请手动确认缴费状态！', '提示', {

              //   cancelButtonText: '取消',
              //   type: 'warning',
              // })
              //   .then(() => {
              //     this.resetAllData();
              //   })
              //   .catch(() => {
              //     // });
              //     //重置数据
              //     this.resetAllData();
              //   });
            }
            if (this.payInfo2.countdown % 5 === 0) {
              spacePayQuery({ orderNo: this.payInfo.orderNo }).then(({ data }) => {
                this.payInfo2.payStatus = data.payStatus;
                if (parseInt(data.payStatus) == 1) {
                  this.payInfo2.showQrCode = false;
                  this.$message.success('支付成功');
                  this.$emit('success');
                  this.isSuccess = true;
                  clearInterval(this.payInfo2.timer);

                  // 可以打印
                  // this.printprev();

                  // this.submitAllBill();
                }
              });
            }
            this.payInfo2.countdown--;
          }, 1000);
        }
      ).catch(err => {
        this.paySubtnFlag = true;
      });

    },
     // 生成收款二维码
     qrCodePay() {
      spacePay(this.form,{ showLoading: { text: '正在获取二维码信息' } }).then(
        ({ data }) => {
          this.payInfo2.showQrCode= true
          this.payInfo.orderNo = data.orderNo;
          this.$nextTick(() => {
            new QRCode('qrcodeCar', {
              width: 250,
              height: 250,
              text: data.qrCodeUrl,
            });
          });
          this.payInfo2.countdown = 120;
          this.payInfo2.timer = setInterval(() => {
            if (this.payInfo2.countdown === 0) {
              clearInterval(this.payInfo2.timer);
              this.payInfo2.showQrCode = false;
              this.$message.info('倒计时结束，二维码弹窗关闭');
              this.$emit('success');
              // this.$confirm('收费失败，请手动确认缴费状态！', '提示', {

              //   cancelButtonText: '取消',
              //   type: 'warning',
              // })
              //   .then(() => {
              //     this.resetAllData();
              //     // let { tag, key } = this.findTag('/v4ward/fundpay/fundpay-abnormal');
              //     // this.$store.commit('DEL_TAG', tag);
              //     // this.$router.push({ path: `/v4ward/fundpay/fundpay-abnormal` });
              //   })
              //   .catch(() => {
              //     // });
              //     //重置数据
              //     this.resetAllData();
              //   });
            }
            if (this.payInfo2.countdown % 5 === 0) {
              spacePayQuery({ orderNo: this.payInfo.orderNo }).then(({ data }) => {
                this.payInfo2.payStatus = data.payStatus;
                if (parseInt(data.payStatus) == 1) {
                  this.payInfo2.showQrCode = false;
                  this.$message.success('支付成功');
                  this.$emit('success');
                  this.isSuccess = true;
                  clearInterval(this.payInfo2.timer);

                  // 可以打印
                  // this.printprev();

                  // this.submitAllBill();
                }
              });
            }
            this.payInfo2.countdown--;
          }, 1000);
        }
      ).catch(err => {
        this.paySubtnFlag = true;
      });
    },
    resetAllData() {
      this.payInfo2.showQrCode = false;
      clearInterval(this.payInfo2.timer);
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-16 {
  height: 54px;
}
</style>
